import * as d3 from "d3";
import "leaflet.markercluster";

window.XMLSerializer = require("xmlserializer");
export default {
  computed: {
    LocationList() {
      var locations = this.getClientLocations();
      var list = [];
      locations.forEach(location => {
        var total = this.getLocationTotal(location.Id);
        if (total > 0 || this.selectedLocations.indexOf(location.Id) > -1) {
          location.SelectText =
            location.Name + ": (" + total.toLocaleString() + ")";
          location.Total = total;
          list.push(location);
        }
      });
      return list.sort(function(a, b) {
        return b.Total - a.Total;
      });
    }
  },
  data() {
    return {
      MAP_HELPER_MIXIN_NAMESPACE: "",
      clusterIdMap: {},
      currentTab: 0,
      currentOverviewMapIntervalRefreshTime: 5 * (60 * 1000),
      drawer: null,
      drawerActivator: null,
      fetchingExcelDoc: false,
      gridTabs: [
        {
          key: "clientTab",
          label: "Client Overview"
        },
        {
          key: "locationTab",
          label: "Location Overview"
        }
      ],
      loading: false,
      map: null,
      // eslint-disable-next-line
      markerclusters: {},
      markerIdMap: {},
      markers: [],
      markerStats: {
        min: 1,
        max: 1
      },
      minimumPackageValue: 0,
      minimumPackageValueText: "",
      packageData: [],
      packageDetailSpiderMarkers: [],
      descending: true,
      sortBy: "Total",
      refreshing: false,
      selectedClients: [],
      selectedFilters: [],
      selectedFiltersFiltered: [],
      selectedLocationDetailWeb: null,
      selectedLocations: [],
      showGrid: true,
      showMap: true,
      showRefrigeratedOnly: false,
      statusProperties: {
        /*
        Manifested: {
          Label: "Manifested",
          Color: "#b30000",
          Priority: 9,
          Key: "Manifested",
          HeaderText: "Manifested",
          HeaderSubText: " ",
          FilterDefault: false,
          ShortLabel: "Manifest"
        },
        */
        "At Origin": {
          Label: "At Origin",
          Class: "AtOriginStatus",
          Priority: 8,
          Key: "At Origin",
          HeaderText: "At Origin",
          HeaderSubText: " ",
          FilterDefault: true,
          ShortLabel: "Origin"
        },
        "At Origin - Departed": {
          Label: "At Origin Departed",
          Class: "AtOriginDepartedStatus",
          Priority: 7,
          Key: "At Origin - Departed",
          HeaderText: "At Origin",
          HeaderSubText: "Departed",
          FilterDefault: true,
          ShortLabel: "Origin Dep."
        },
        "In Transit - Arrived": {
          Label: "In Transit Arrived",
          Class: "InTransitArrivedStatus",
          Priority: 6,
          Key: "In Transit - Arrived",
          HeaderText: "In Transit",
          HeaderSubText: "Arrived",
          FilterDefault: true,
          ShortLabel: "Transit Arr."
        },
        "In Transit - Departed": {
          Label: "In Transit Departed",
          Class: "InTransitDepartedStatus",
          Priority: 5,
          Key: "In Transit - Departed",
          HeaderText: "In Transit",
          HeaderSubText: "Departed",
          FilterDefault: true,
          ShortLabel: "Transit Dep."
        },
        "At Destination Metro": {
          Label: "At Dest. Metro",
          Class: "AtDestinationMetroStatus",
          Priority: 4,
          Key: "At Destination Metro",
          HeaderText: "At Dest.",
          HeaderSubText: "Metro",
          FilterDefault: false,
          ShortLabel: "Dest. Metro"
        },
        "At Delivery Facility": {
          Label: "At Delivery Facility",
          Class: "AtDeliveryFacilityStatus",
          Priority: 3,
          Key: "At Delivery Facility",
          HeaderText: "At Delivery",
          HeaderSubText: "Facility",
          FilterDefault: false,
          ShortLabel: "Delivery Facility"
        },
        "Out For Delivery - Delayed": {
          Label: "Out For Delivery Delayed",
          Class: "OutForDeliveryDelayedStatus",
          Priority: 2,
          Key: "Out For Delivery - Delayed",
          HeaderText: "Out For Delivery",
          HeaderSubText: "Delayed",
          FilterDefault: false,
          ShortLabel: "Out For Delivery Delayed"
        },
        Voided: {
          Label: "Voided",
          Class: "VoidedStatus",
          Priority: 1,
          Key: "Voided",
          HeaderText: "Voided",
          HeaderSubText: " ",
          FilterDefault: false,
          ShortLabel: "Voided"
        },
        Other: {
          Label: "Other",
          Class: "OtherStatus",
          Priority: 0,
          Key: "Other",
          HeaderText: "Other",
          HeaderSubText: " ",
          FilterDefault: false,
          ShortLabel: "Other"
        }
      },
      subTableHeaders: [
        {
          text: "Tracking #",
          value: "TrackingNumber",
          align: "left"
        },
        {
          text: "Order #",
          value: "OrderNumber",
          align: "left"
        },
        {
          text: "Transit Status",
          value: "TransitStatus",
          align: "left"
        },
        {
          text: "Dest. City",
          value: "DestCity",
          align: "left"
        },
        {
          text: "Dest. State",
          value: "DestState",
          align: "left"
        },
        {
          text: "Service",
          value: "Service",
          align: "left"
        },
        {
          text: "Refrigerated",
          value: "IsRefrigerated",
          align: "left"
        },
        {
          text: "Value",
          value: "ContentsValue",
          align: "left"
        }
      ],
      subTableDescending: true,
      subTableSortBy: "ContentsValue",
      transitFilter: {},
      transitStatus: []
    };
  },
  methods: {
    changeSort(column) {
      if (this.sortBy === column) {
        this.descending = !this.descending;
      } else {
        this.sortBy = column;
        this.descending = false;
      }
    },
    clearFilters() {
      this.selectedFilters = [];
      this.transitStatus.forEach(x => {
        this.transitFilter[x.key] = true;
        x.active = true;
      });
      this.filter();
    },
    clearPackageWeb() {
      /* istanbul ignore next */
      try {
        this.packageDetailSpiderMarkers.forEach(marker => {
          this.map.removeLayer(marker);
        });
      } catch (e) {}
      this.packageDetailSpiderMarkers = [];
      this.markerclusters.refreshClusters();
      this.selectedLocationDetailWeb = null;
    },
    clearSelectedTags() {
      this.packageData.forEach(x => {
        x.Selected = false;
      });
    },
    drawMarkers() {
      this.getTableData(this.currentTab);
      this.markers = this.getMarkerData(this.packageData);
      // if(!this.refreshing)this.zoomToShowAllMarkers();
      var data = {
        type: "FeatureCollection",
        features: this.markers,
        properties: {}
      };
      // eslint-disable-next-line
      var points = L.geoJson(data, {
        pointToLayer: this.getSingleLocationMarker
      });
      this.markerclusters.clearLayers();
      this.markerclusters.addLayer(points);
      this.markerStats = this.getShownMarkerTotals();
      this.markerclusters.refreshClusters();
      this.loading = false;
      this.refreshing = false;
    },
    drawerOpen() {
      this.drawer = this.$store.drawerOpen.open;
      this.drawerActivator = this.$store.drawerOpen;
      return this.$store.drawerOpen.open;
    },
    expandTableRow(id) {
      this.$set(this.$refs.packageDataTable.expanded, id, true);
    },
    exportDataToExcel() /* istanbul ignore next */ {
      this.fetchingExcelDoc = true;
      return this.$store
        .dispatch(
          `${this.MAP_HELPER_MIXIN_NAMESPACE}/EXPORT_DATA_TO_EXCEL`,
          this.getExcelData()
        )
        .then(value => {
          this.fetchingExcelDoc = false;
          var binaryString = window.atob(value);
          var binaryLen = binaryString.length;
          var bytes = new Uint8Array(binaryLen);
          for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
          }
          var blob = new Blob([bytes], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          var fileName = "Package Report_" + new Date().toLocaleString();
          link.download = fileName;
          link.click();
        });
    },
    filter(key) {
      if (key) this.transitFilter[key] = !this.transitFilter[key];
      this.selectedFiltersFiltered = [];
      this.transitStatus.forEach(x => {
        if (this.transitFilter[x.key] === true) x.active = true;
        else {
          x.active = false;
          this.selectedFiltersFiltered.push(x.key);
        }
      });
      this.$forceUpdate();
      this.drawMarkers();
      /* istanbul ignore if */
      if (this.selectedLocationDetailWeb) {
        this.resetSelectedLocationDetailWeb();
      } else this.clearPackageWeb();
    },
    filterPriority(key) {
      for (var propertyName in this.transitFilter) {
        if (
          this.statusProperties[propertyName].Priority >=
          this.statusProperties[key].Priority
        )
          this.transitFilter[propertyName] = true;
        else this.transitFilter[propertyName] = false;
      }
      this.transitFilter[key] = true;
      this.filter();
    },
    getCenterLeft() {
      if (this.drawerOpen())
        return "calc(50% + " + this.$store.navWidth / 2 + "px)";
      return "50%";
    },
    getCityState(city, state) {
      if (city && state) return city + ", " + state;
      else if (city && state == null) return city;
      else if (city == null && state) return state;
      else return "";
    },
    getClientLocations() {
      var locations = [];
      this.selectedClients.forEach(id => {
        let client = this.clientData.find(x => x.Id === id);
        if (client) locations = locations.concat(client.Locations);
      });
      return locations;
    },
    getClientName(clientId) {
      var client = this.clientData.find(x => {
        if (clientId === 3) clientId = 4;
        return x.Id === clientId;
      });
      if (client) {
        return client.Name;
      }
      return "";
    },
    getClientTableData() {
      var tableData = [];
      this.originalData.forEach(d => {
        var data = {};
        data.Id = d.Id;
        data.CityState = this.getCityState(d.City, d.State);
        data.City = d.City;
        data.State = d.State;
        data.Lat = d.Lat;
        data.Lng = d.Lon;
        data.PackageDetails = d.Detail;
        data.Value = 0;
        data.Refrigerated = 0;
        for (let key in this.statusProperties) {
          data[key] = 0;
        }
        d.Detail.forEach(p => {
          if (
            p.ContentsValue >= this.minimumPackageValue &&
            (!this.showRefrigeratedOnly || p.IsRefrigerated) &&
            this.transitFilter[p.TransitStatus] === true
          ) {
            data[p.TransitStatus] += 1;
            data.Value += p.ContentsValue;
            if (p.IsRefrigerated) data.Refrigerated += 1;
          }
        });
        data.Total = this.getDataTotal(data);
        if (data.Total > 0) tableData.push(data);
      });
      return tableData;
    },
    getClusterData(layer, data) {
      if (layer._markers.length > 0) {
        layer._markers.forEach(marker => {
          for (let propertyName in marker.feature.properties.Data) {
            if (data.hasOwnProperty(propertyName)) {
              data[propertyName] +=
                marker.feature.properties.Data[propertyName];
            } else {
              data[propertyName] = marker.feature.properties.Data[propertyName];
            }
          }
        });
      }
      if (layer._childClusters.length > 0) {
        layer._childClusters.forEach(cluster => {
          data = this.getClusterData(cluster, data);
        });
      }
      return data;
    },
    getClusterLocationMarker(cluster) {
      var children = cluster.getAllChildMarkers();
      var label = "Locations: " + children.length;
      var makeMarker = false;

      var svgClass = "svg-cluster-" + cluster._leaflet_id;
      if (children.length === 1) {
        label = children[0].feature.properties.Name;
        svgClass = "svg-cluster-marker-" + children[0].feature.properties.Id;
        makeMarker = this.isLatLngInMapBounds(
          children[0].feature.properties.Lat,
          children[0].feature.properties.Lng,
          this.map
        );
      } else {
        makeMarker = this.isLatLngInMapBounds(
          cluster._cLatLng.lat,
          cluster._cLatLng.lng,
          this.map
        );
      }

      var total = d3.sum(children, function(d) {
        return d.feature.properties.Total;
      });
      if (makeMarker) {
        var wedgeData = {};
        for (let status in this.statusProperties) {
          wedgeData[status] = d3.sum(children, function(d) {
            return d.feature.properties.Data[status];
          });
        }
        children.forEach(x => {
          x.feature.properties.Ids.forEach(id => {
            if (cluster._leaflet_id) this.clusterIdMap[id] = svgClass;
            else this.markerIdMap[id] = svgClass;
          });
        });

        var html = this.getLocationMarkerHtml({
          total: total,
          infoboxClass: "infobox-cluster-" + cluster._leaflet_id,
          svgClass: svgClass,
          wedgeData: wedgeData,
          label: label,
          numLocations: children.length,
          markerStats: this.markerStats,
          statusProperties: this.statusProperties
        });
        var className = "marker-cluster";
        if (this.packageDetailSpiderMarkers.length > 0)
          className += " fade-circle";
        if (children.length > 1) className += " multi-location-cluster";
        else className += " single-location-cluster";
        var sizes = this.getMarkerSizes(total, this.markerStats);
        // eslint-disable-next-line
        return new L.DivIcon({
          html: html,
          className: className,
          // eslint-disable-next-line
          iconSize: new L.Point(sizes.radius, sizes.radius)
        });
      } else {
        // eslint-disable-next-line
        return new L.DivIcon({
          html:
            "<div class='marker-total-text' style='display: none;'>" +
            total +
            "</div>",
          // eslint-disable-next-line
          iconSize: new L.Point(0, 0)
        });
      }
    },
    getClusterTotal(layer, total) {
      if (layer._markers.length > 0) {
        layer._markers.forEach(marker => {
          total += marker.feature.properties.Total;
        });
      }
      if (layer._childClusters.length > 0) {
        layer._childClusters.forEach(cluster => {
          total = this.getClusterTotal(cluster, total);
        });
      }
      return total;
    },
    getDataTotal(data) {
      var total = 0;
      for (let key in this.statusProperties) {
        if (data[key] && this.transitFilter[key] === true) total += data[key];
      }
      return total;
    },
    getExcelData() {
      var summaryData = [];
      var detailData = [];
      var summaryKeys = ["City", "State"];
      var detailKeys = [
        "TrackingNumber",
        "OrderNumber",
        "TransitStatus",
        "CurrentCity",
        "CurrentState",
        "ContentsValue",
        "IsRefrigerated",
        "Service",
        "DestCity",
        "DestState"
      ];
      if (this.currentTab === 1) {
        summaryKeys.push("LocationName");
        detailKeys.push("LocationName");
      }
      summaryKeys = summaryKeys.concat(["Total", "Value", "Refrigerated"]);

      for (let key in this.transitFilter) {
        if (this.transitFilter[key] === true) {
          summaryKeys.push(this.stripKey(key));
        }
      }
      this.packageData.forEach(s => {
        if (
          this.currentTab === 0 ||
          this.selectedLocations.length === 0 ||
          this.selectedLocations.indexOf(s.LocationId) > -1
        ) {
          var summary = {
            City: s.City,
            State: s.State,
            Total: s.Total,
            Value: s.Value,
            Refrigerated: s.Refrigerated,
            LocationName: s.LocationName
          };
          for (let key in this.transitFilter) {
            if (this.transitFilter[key] === true) {
              summary[this.stripKey(key)] = s[key];
            }
          }
          summaryData.push(summary);
          s.PackageDetails.forEach(d => {
            if (
              (d.IsRefrigerated || this.showRefrigeratedOnly === false) &&
              d.ContentsValue >= this.minimumPackageValue &&
              this.transitFilter[d.TransitStatus] === true
            ) {
              detailData.push({
                TrackingNumber: d.TrackingNumber,
                OrderNumber: d.OrderNumber,
                TransitStatus: d.TransitStatus,
                DestCity: d.DestCity,
                DestState: d.DestState,
                Service: d.Service,
                CurrentCity: s.City,
                CurrentState: s.State,
                IsRefrigerated: d.IsRefrigerated ? "Yes" : "",
                ContentsValue: d.ContentsValue,
                LocationName: this.getLocationName(d.ClientId, d.LocationId)
              });
            }
          });
        }
      });

      var pagination;
      /* istanbul ignore if */
      if (this.$refs.packageDataTable) {
        pagination = this.$refs.packageDataTable;
        if (pagination.sortBy)
          summaryData = this.sort(
            summaryData,
            pagination.descending,
            this.stripKey(pagination.sortBy)
          );
        else summaryData = this.sort(summaryData, true, "Total");
      } else {
        summaryData = this.sort(summaryData, true, "Total");
      }

      /* istanbul ignore if */
      if (this.$refs.packageDetailDataTable) {
        pagination = this.$refs.packageDetailDataTable;
        if (pagination.sortBy)
          detailData = this.sort(
            detailData,
            pagination.descending,
            this.stripKey(pagination.sortBy)
          );
        else detailData = this.sort(detailData, true, "ContentsValue");
      } else {
        detailData = this.sort(detailData, true, "ContentsValue");
      }

      return {
        SummaryData: summaryData,
        DetailData: detailData,
        SummaryKeys: summaryKeys,
        DetailKeys: detailKeys
      };
    },
    getGridWidth() {
      if (this.drawerOpen())
        return "calc(100% - " + this.$store.navWidth + "px)";
      return "100%";
    },
    getHeaders(key) {
      var headers = [];
      if (this.currentTab !== 0 && this.selectedLocations.length !== 1) {
        headers.push({
          text: "Location",
          value: "LocationName",
          align: "left",
          class: "main-header"
        });
      }
      headers = headers.concat([
        {
          text: "City",
          value: "City",
          align: "left",
          class: "main-header"
        },
        {
          text: "State",
          value: "State",
          align: "left",
          class: "main-header"
        },
        {
          text: "Total",
          value: "Total",
          align: "center",
          totalKey: "Total",
          class: "main-header"
        }
      ]);
      for (let key in this.statusProperties) {
        if (this.transitFilter[key] === true) {
          headers.push({
            text: this.statusProperties[key].HeaderText,
            value: key,
            align: "center",
            subText: this.statusProperties[key].HeaderSubText,
            totalKey: key,
            class: ["main-header", "transit-status-header"]
          });
        }
      }
      headers = headers.concat([
        {
          text: "Value",
          value: "Value",
          align: "Center",
          totalKey: "Value",
          class: "main-header"
        },
        {
          text: "Refrig.",
          value: "Refrigerated",
          align: "center",
          totalKey: "Refrigerated",
          class: "main-header"
        }
      ]);
      return headers;
    },
    getHeaderTotal(key) {
      var total = 0;
      this.packageData.forEach(p => {
        if (this.isSelectedLocation(p.LocationId) || this.currentTab === 0) {
          if (p[key]) total += p[key];
        }
      });
      if (key === "Value") return "$" + total.toLocaleString("USD");
      return total;
    },
    getLocationMarkerHtml(options) {
      var sizes = this.getMarkerSizes(options.total, options.markerStats);
      var markerSize = sizes.radius;
      var fontSize = sizes.fontSize;
      var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      var s = d3.select(svg);
      s.attr("width", markerSize)
        .attr("height", markerSize)
        .attr("class", options.svgClass);

      s.append("g");
      var g = s.select("g");

      g.attr("class", "donut")
        .attr("width", markerSize)
        .attr("height", markerSize)
        .attr("transform", function(d) {
          return "translate(" + markerSize / 2 + "," + markerSize / 2 + ")";
        });

      g.append("circle")
        .attr("fill", "#000")
        .attr("r", markerSize / 4);

      var wedges = [];
      _.each(options.wedgeData, function(e, i, l) {
        wedges.push({
          name: i,
          value: e / options.total,
          class: options.statusProperties[i].Class
        });
      });

      var arc = d3
        .arc()
        .innerRadius(markerSize / 4)
        .outerRadius(markerSize / 2);

      const pie = d3
        .pie()
        .value(d => d.value)
        .sort(null);

      g.selectAll("path")
        .data(pie(wedges))
        .enter()
        .append("path")
        .attr("class", function(d, i) {
          var c = d.data.class + "-fill ";
          if (d.data.value > 0) c += d.data.name + "-data-wedge";
          return c;
        })
        .attr("d", arc)
        .each(function(d) {
          this._current = d;
        });
      g.append("circle")
        .attr("fill", "transparent")
        .attr("class", "highlight-circle")
        .attr("stroke-width", 4)
        .attr("stroke", "transparent")
        .attr("r", markerSize / 2 - 2);

      if (options.numLocations > 1) {
        var locR = options.numLocations.toLocaleString().length * 2 + 5;
        var offset = -markerSize / 3 + locR / 4;
        g.append("circle")
          .attr("pointer-events", "none")
          .attr("stroke-width", "0.5")
          .attr("fill", "#FFF")
          .attr("stroke", "#000")
          .attr("cx", offset)
          .attr("cy", offset)
          .attr("r", locR);
        g.append("text")
          .attr("class", "total-markers")
          .attr("pointer-events", "none")
          .attr("text-anchor", "middle")
          .attr("dy", ".30em")
          .style("font-size", 9 + "px")
          .style("font-weight", "600")
          .attr("fill", "#000")
          .attr("x", offset)
          .attr("y", offset)
          .text(options.numLocations.toLocaleString());
      } else {
        g.append("text")
          .attr("class", "total-markers")
          .attr("pointer-events", "none")
          .style("display", "none")
          .attr("x", offset)
          .attr("y", offset)
          .text(1);
      }
      g.append("text")
        .attr("pointer-events", "none")
        .attr("text-anchor", "middle")
        .attr("class", "marker-total-text")
        .attr("dy", ".30em")
        .style(
          "text-shadow",
          "-1px 0 black, 0 1px black, 1px 0 black, 0 -1px black"
        )
        .style("font-size", fontSize + "px")
        .attr("fill", "#FFF")
        .text(options.total.toLocaleString());
      if (options.hashKey) {
        g.append("a")
          .attr("class", "marker-link no-pointer-events")
          .attr("xlink:href", "/potential-calamities-report/" + options.hashKey)
          .append("circle")
          .attr("r", markerSize / 4)
          .style("fill", "transparent");
      }
      return this.serializeXmlNode(svg);
    },
    getLocationName(clientId, locationId) {
      var client = this.clientData.find(x => {
        return x.Id === clientId;
      });
      if (client) {
        var location = client.Locations.find(x => {
          return x.Id === locationId;
        });
        if (location) return location.Name;
      }
      return "";
    },
    getLocationTableData() {
      var tableData = [];
      this.originalData.forEach(d => {
        var loc = {};
        d.Detail.forEach(p => {
          if (!loc[p.LocationId]) {
            loc[p.LocationId] = {
              Value: 0,
              Refrigerated: 0,
              ClientId: p.ClientId
            };
            for (let key in this.statusProperties) {
              loc[p.LocationId][key] = 0;
            }
          }
          if (
            p.ContentsValue >= this.minimumPackageValue &&
            (!this.showRefrigeratedOnly || p.IsRefrigerated) &&
            this.transitFilter[p.TransitStatus] === true
          ) {
            loc[p.LocationId][p.TransitStatus] += 1;
            loc[p.LocationId].Value += p.ContentsValue;
            if (p.IsRefrigerated) loc[p.LocationId].Refrigerated += 1;
          }
        });
        for (let id in loc) {
          var data = {};
          data.Id = d.Id + "-" + id;
          data.CityState = this.getCityState(d.City, d.State);
          data.City = d.City;
          data.State = d.State;
          data.Lat = d.Lat;
          data.Lng = d.Lon;
          data.LocationId = parseInt(id);
          data.LocationName = this.getLocationName(
            loc[id].ClientId,
            parseInt(id)
          );
          data.ClientName = this.getClientName(loc[id].ClientId);
          data.PackageDetails = d.Detail.filter(x => {
            return x.LocationId === parseInt(id);
          });
          data.Value = loc[id].Value;
          data.Refrigerated = loc[id].Refrigerated;
          for (let key in this.statusProperties) {
            data[key] = loc[id][key];
          }
          data.Total = this.getDataTotal(loc[id]);
          if (data.Total > 0) tableData.push(data);
        }
      });
      return tableData;
    },
    getLocationTotal(id) {
      var total = 0;
      this.packageData.forEach(p => {
        if (p.LocationId === id) total += p.Total;
      });
      return total;
    },
    getMarkerData(data) {
      var markers = [];
      data.forEach(d => {
        if (
          (this.currentTab === 0 ||
            this.selectedLocations.length === 0 ||
            (this.currentTab > 0 &&
              this.selectedLocations.length > 0 &&
              this.selectedLocations.indexOf(d.LocationId) > -1)) &&
          d.Lat !== 0 &&
          d.Lng !== 0
        ) {
          var isMerged = false;
          var sameLoc = markers.find(m => {
            return d.Lat === m.properties.Lat && d.Lng === m.properties.Lng;
          });
          if (sameLoc) {
            isMerged = true;
            for (let key in this.statusProperties) {
              if (this.transitFilter[key] === true) {
                if (!sameLoc.properties.Data[key])
                  sameLoc.properties.Data[key] = 0;
                if (!d[key]) d[key] = 0;
                sameLoc.properties.Total += d[key];
                sameLoc.properties.Data[key] += d[key];
              }
            }
            sameLoc.properties.PackageDetails = sameLoc.properties.PackageDetails.concat(
              d.PackageDetails
            );
            sameLoc.properties.Ids.push(d.Id);
          }
          var total = 0;
          var wedgeData = {};
          for (let key in this.statusProperties) {
            if (this.transitFilter[key] === true) {
              if (d[key]) total += d[key];
              wedgeData[key] = d[key];
            }
          }
          if (total > 0 && !isMerged)
            markers.push({
              geometry: {
                type: "Point",
                coordinates: [d.Lng, d.Lat]
              },
              type: "Feature",
              properties: {
                Name: d.CityState,
                PackageDetails: d.PackageDetails,
                Total: total,
                Data: wedgeData,
                Lat: d.Lat,
                Lng: d.Lng,
                hashKey: d.HashKey,
                Id: d.Id,
                Ids: [d.Id]
              }
            });
        }
      });
      return markers;
    },
    getMarkerSizes(t, markerStats) {
      var radiusMinMax = {
        min: 45,
        max: 120
      };

      var fontMinMax = {
        min: 12,
        max: 20
      };

      if (t <= 10)
        return {
          radius: radiusMinMax.min,
          fontSize: fontMinMax.min
        };

      var r = radiusMinMax.min;
      var fS = fontMinMax.min;

      if (!isNaN(markerStats.max) && markerStats.max > 0) {
        if (markerStats.max === markerStats.min) {
          r = radiusMinMax.max;
          fS = fontMinMax.max;
        } else {
          // eslint-disable-next-line
          r = radiusMinMax.min + ((radiusMinMax.max - radiusMinMax.min) * (t - markerStats.min)) / (markerStats.max - markerStats.min);
          // eslint-disable-next-line
          fS = fontMinMax.min + ((fontMinMax.max - fontMinMax.min) * (t - markerStats.min)) / (markerStats.max - markerStats.min);
        }
      }

      if (r > radiusMinMax.max) r = radiusMinMax.max;
      if (fS > fontMinMax.max) fS = fontMinMax.max;
      if (r < radiusMinMax.min) r = radiusMinMax.min;
      if (fS < fontMinMax.min) fS = fontMinMax.min;
      return {
        radius: Math.ceil(r),
        fontSize: Math.ceil(fS)
      };
    },
    getPackageDetailMarker(detail) {
      // eslint-disable-next-line
      var icon = new L.DivIcon({
        html:
          '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"><g class="donut" width="20" height="20" transform="translate(10,10)"><circle stroke="' +
          "black" +
          '" class="' +
          this.statusProperties[detail.TransitStatus].Class +
          "-fill package-detail-marker" +
          '" r="10" stroke-width="2" fill-opacity="0.4"></circle></g></svg>',
        className:
          "packageDetailMarker marker-tn-" +
          detail.TrackingNumber +
          " marker-key-" +
          this.stripKey(detail.TransitStatus)
      });
      // eslint-disable-next-line
      var marker = L.marker(
        { lat: detail.DestLat, lng: detail.DestLon },
        { icon: icon }
      );
      // var self = this;
      return marker;
    },
    getPopupHtml(label, data, statusProperties, hashKey) {
      var potentialLink = 'style="text-decoration: none; color: black;"';
      if (hashKey)
        potentialLink =
          'style="color: black;" href="/potential-calamities-report/' +
          hashKey +
          '" ';
      var html =
        "<div><a " +
        potentialLink +
        ' ><h5 style="padding:3px 0 5px 5px;">' +
        label +
        '</h5></a><table style="min-width: 185px;">';
      for (let propertyName in data) {
        if (data[propertyName] > 0) {
          html += "<tr>";
          html +=
            '<td><i class="material-icons ' +
            statusProperties[propertyName].Class +
            '-icon">label</i>';
          html += "<td>" + statusProperties[propertyName].Label + "</td>";
          html += "<td>" + data[propertyName].toLocaleString() + "</td>";
          html += "</tr>";
        }
      }
      html += "</table></div>";
      return html;
    },
    getShownMarkerTotals() {
      var totals = [];
      d3.selectAll(".marker-total-text").each(function() {
        totals.push(
          parseInt(
            d3
              .select(this)
              .text()
              .replace(/,/g, "")
          )
        );
      });
      return {
        min: d3.min(totals, function(d) {
          return d;
        }),
        max: d3.max(totals, function(d) {
          return d;
        })
      };
    },
    getSingleLocationMarker(feature, latlng) {
      var html = this.getLocationMarkerHtml({
        total: feature.properties.Total,
        infoboxClass: "infobox-marker-" + feature.properties.Id,
        svgClass: "svg-marker-" + feature.properties.Id,
        wedgeData: feature.properties.Data,
        label: feature.properties.Name,
        hashKey: feature.properties.HashKey,
        markerStats: this.markerStats,
        statusProperties: this.statusProperties
      });
      var className = "marker-cluster";
      if (this.packageDetailSpiderMarkers.length > 0)
        className += " fade-circle";
      var sizes = this.getMarkerSizes(
        feature.properties.Total,
        this.markerStats
      );
      // eslint-disable-next-line
      var icon = new L.DivIcon({
        html: html,
        className: className,
        // eslint-disable-next-line
        iconSize: new L.Point(sizes.radius, sizes.radius)
      });
      // eslint-disable-next-line
      return L.marker(latlng, { icon: icon });
    },
    getTableData(tabId) {
      var data = [];
      if (tabId === 0) data = this.getClientTableData();
      else if (tabId === 1) data = this.getLocationTableData();
      this.packageData = data;
      return data;
    },
    getTableHeightPercent() {
      if (!this.showGrid) return "0%";
      else if (!this.showMap) return "100%";
      else if (window.innerWidth < 760) return "50%";
      return "40%";
    },
    getTrackingUrl(number) {
      if (!isNaN(number) && (number.length === 12 || number.length === 15)) {
        // FedEx Tracking
        return (
          "http://www.fedex.com/Tracking?action=track&tracknumbers=" + number
        );
      } else if (number.length === 18 && number.indexOf("1Z") === 0) {
        // UPS Tracking
        return (
          "http://wwwapps.ups.com/WebTracking/track?track=yes&trackNums=" +
          number
        );
      } else if (
        (number.length === 20 && !isNaN(number)) ||
        number.length === 13
      ) {
        // USPS Tracking
        return "https://tools.usps.com/go/TrackConfirmAction?tLabels=" + number;
      }
    },
    highlightCircle(id, show) {
      var c = d3.selectAll("." + this.clusterIdMap[id]);
      c.classed("highlight-circle", show);
      var m = d3.selectAll("." + this.markerIdMap[id]);
      m.classed("highlight-circle", show);
    },
    highlightDetailMarker(tracking, show) {
      var c = d3.selectAll(".highlight-detail-marker");
      c.classed("highlight-detail-marker", false);

      var d = d3.selectAll(".marker-tn-" + tracking);
      d.classed("highlight-detail-marker", show);
    },
    highlightPackageDetailMarkerByKey(key, show) {
      var c = d3.selectAll(".highlight-detail-marker");
      c.classed("highlight-detail-marker", false);

      var d = d3.selectAll(".marker-key-" + this.stripKey(key));
      d.classed("highlight-detail-marker", show);
    },
    initFilters() {
      this.transitStatus = [];
      for (let status in this.statusProperties) {
        this.transitStatus.push({
          label: this.statusProperties[status].Label,
          key: status,
          active: this.statusProperties[status].FilterDefault
        });
        // eslint-disable-next-line
        this.transitFilter[status] = this.statusProperties[
          status
        ].FilterDefault;
        if (this.statusProperties[status].FilterDefault === false)
          this.selectedFilters.push(status);
      }
      this.filter();
    },
    initMap() {
      /* eslint-disable */
      var tileLayer = L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png");

      var map = L.map("map", {
        center: [37, -97],
        zoom: 4.5,
        maxZoom: 18,
        minZoom: 0,
        zoomSnap: 0,
        zoomDelta: 0.85,
        wheelPxPerZoomLevel: 40,
        layers: tileLayer
      }).setView([37, -97], 5);

      var southWest = L.latLng(-90, -240)
      var northEast = L.latLng(90, 180);
      var bounds = L.latLngBounds(southWest, northEast);
      /* eslint-enable */
      map.setMaxBounds(bounds);
      return map;
    },
    initOverviewMap() {
      this.map = this.initMap();
      // Breaks Tests
      try {
        // eslint-disable-next-line
        this.markerclusters = new L.MarkerClusterGroup({
          maxClusterRadius: 60,
          iconCreateFunction: this.getClusterLocationMarker,
          showCoverageOnHover: false,
          zoomToBoundsOnClick: false,
          singleMarkerMode: true
        });
        this.map.addLayer(this.markerclusters);
      } catch (e) {}

      var self = this;
      /* istanbul ignore next */
      this.map.on("zoomstart", function() {
        self.map.closePopup();
      });
      /* istanbul ignore next */
      this.map.on("zoomend", function() {
        setTimeout(() => {
          self.markerStats = self.getShownMarkerTotals();
          self.markerclusters.refreshClusters();
        }, 300);
        self.packageData.forEach(x => {
          x.Selected = false;
        });
      });
      /* istanbul ignore next */
      this.map.on("moveend", function() {
        self.markerclusters.refreshClusters();
      });
      /* istanbul ignore next */
      this.map.on("click", () => {
        self.clearPackageWeb();
      });
      /* istanbul ignore next */
      this.markerclusters
        .on("clusterclick", function(c) {
          // eslint-disable-next-line
          L.popup()
            .setLatLng(c.layer.getLatLng())
            .setContent(
              self.getPopupHtml(
                "Locations: " + c.layer._childCount.toLocaleString(),
                self.getClusterData(c.layer, {}),
                self.statusProperties
              )
            )
            .openOn(self.map);
        })
        .on("clustermouseover", function(c) {
          // eslint-disable-next-line
          L.popup()
            .setLatLng(c.layer.getLatLng())
            .setContent(
              self.getPopupHtml(
                "Locations: " + c.layer._childCount.toLocaleString(),
                self.getClusterData(c.layer, {}),
                self.statusProperties
              )
            )
            .openOn(self.map);
          self.clearSelectedTags();
          self.showClusterTableRows(c.layer);
          self.$forceUpdate();
        })
        .on("clustermouseout", function(c) {
          self.map.closePopup();
          self.clearSelectedTags();
          self.$forceUpdate();
        })
        .on("clusterdblclick", function(c) {
          self.clearPackageWeb();
          self.clearSelectedTags();
          var map = document.getElementById("map");
          var paddingBottom = 50;
          if (self.showGrid) paddingBottom = map.offsetHeight * 0.5;
          var paddingLeft = 50;
          if (self.drawerOpen()) paddingLeft = self.$store.navWidth + 50;
          self.map.fitBounds(c.layer.getBounds(), {
            paddingTopLeft: [paddingLeft, 50],
            paddingBottomRight: [50, paddingBottom]
          });
          setTimeout(() => {
            self.markerStats = self.getShownMarkerTotals();
            self.markerclusters.refreshClusters();
            self.map.closePopup();
          }, 1000);
        })
        .on("dblclick", function(c) {
          self.showPackageWeb(c.layer.feature.properties);
          self.expandTableRow(c.layer.feature.properties.Id);
        })
        .on("click", function(c) {
          if (self.selectedLocationDetailWeb) {
            if (
              self.selectedLocationDetailWeb.Id !==
              c.layer.feature.properties.Id
            )
              self.clearPackageWeb();
          }
          var lowestOffsetTop;
          c.layer.feature.properties.Ids.forEach(id => {
            var element = document.getElementById("overview-data-" + id);
            if (!lowestOffsetTop) lowestOffsetTop = element.offsetTop;
            if (element.offsetTop < lowestOffsetTop)
              lowestOffsetTop = element.offsetTop;
          });
          var tableElement = document.getElementById("grid-container");
          var selectorsElement = document.getElementById("filter-selectors");
          tableElement.scrollTop =
            lowestOffsetTop + selectorsElement.offsetHeight - 20;
          var a = d3.selectAll(".marker-link");
          a.classed("no-pointer-events", true);
          // eslint-disable-next-line
          L.popup()
            .setLatLng(c.layer.getLatLng())
            .setContent(
              self.getPopupHtml(
                c.layer.feature.properties.Name,
                c.layer.feature.properties.Data,
                self.statusProperties,
                c.layer.feature.properties.HashKey
              )
            )
            .openOn(self.map);
          setTimeout(function() {
            var a = d3.selectAll(".marker-link");
            a.classed("no-pointer-events", false);
          }, 100);
        })
        .on("mouseover", function(c) {
          var a = d3.selectAll(".marker-link");
          a.classed("no-pointer-events", true);
          // eslint-disable-next-line
          L.popup()
            .setLatLng(c.layer.getLatLng())
            .setContent(
              self.getPopupHtml(
                c.layer.feature.properties.Name,
                c.layer.feature.properties.Data,
                self.statusProperties,
                c.layer.feature.properties.HashKey
              )
            )
            .openOn(self.map);
          setTimeout(function() {
            a.classed("no-pointer-events", false);
          }, 100);
          self.clearSelectedTags();
          self.showTableRow(c.layer.feature.properties.Ids, true);
          self.$forceUpdate();
        })
        .on("mouseout", function(c) {
          var a = d3.selectAll(".marker-link");
          a.classed("no-pointer-events", true);
          self.map.closePopup();
          self.clearSelectedTags();
          self.$forceUpdate();
        });
    },
    isLatLngInMapBounds(lat, lng, map) {
      var bounds = map.getBounds();
      var inLat =
        bounds._southWest.lat - 1 <= lat && lat <= bounds._northEast.lat + 1;
      var inLng =
        bounds._southWest.lng - 1 <= lng && lng <= bounds._northEast.lng + 1;
      return inLat && inLng;
    },
    isSelectedLocation(id) {
      if (this.selectedLocations.length === 0) return true;
      else if (this.selectedLocations.indexOf(id) > -1) return true;
      return false;
    },
    isPackageMarkerTotal(key) {
      if (this.selectedLocationDetailWeb.Data)
        return this.selectedLocationDetailWeb.Data[key] > 0;
      else if (this.selectedLocationDetailWeb[key])
        return this.selectedLocationDetailWeb[key] > 0;
      return false;
    },
    loadClientPackageData(refreshing) {
      if (this.selectedClients.length > 0) {
        if (refreshing) this.refreshing = true;
        else this.loading = true;
        var clientIds = this.selectedClients.join(",");
        var id4 = this.selectedClients.indexOf(4) > -1;
        if (id4) clientIds += ",3";
        return this.$store
          .dispatch(
            `${this.MAP_HELPER_MIXIN_NAMESPACE}/LOAD_CLIENT_PACKAGES`,
            clientIds
          )
          .then(x => {
            this.drawMarkers();
            if (!refreshing) this.zoomToShowAllMarkers();
          });
      } else {
        return this.$store
          .dispatch(`${this.MAP_HELPER_MIXIN_NAMESPACE}/CLEAR_MARKERS`)
          .then(x => {
            this.drawMarkers();
          });
      }
    },
    loadClients() {
      return this.$store.dispatch(
        `${this.MAP_HELPER_MIXIN_NAMESPACE}/LOAD_CLIENTS`
      );
    },
    locationRowDblclick(item) {
      var self = this;
      /* istanbul ignore next */
      setTimeout(() => {
        self.showPackageWeb(item);
      }, 50);
    },
    resetSelectedLocationDetailWeb() {
      var data = this.packageData.find(x => {
        return x.Id === this.selectedLocationDetailWeb.Id;
      });
      if (data) this.showPackageWeb(data);
      else this.clearPackageWeb();
    },
    serializeXmlNode(svg) {
      return window.XMLSerializer.serializeToString(svg);
    },
    setMinimumPackageValue() {
      if (!isNaN(this.minimumPackageValueText)) {
        if (
          this.minimumPackageValueText === "" ||
          this.minimumPackageValueText === null
        )
          this.minimumPackageValue = 0;
        this.minimumPackageValue = Number(this.minimumPackageValueText);
        this.drawMarkers();
        if (this.selectedLocationDetailWeb) {
          this.resetSelectedLocationDetailWeb();
        } else this.clearPackageWeb();
      }
    },
    showClusterTableRows(layer) {
      if (layer._markers.length > 0) {
        layer._markers.forEach(marker => {
          this.showTableRow(marker.feature.properties.Ids);
        });
      }

      if (layer._childClusters.length > 0) {
        layer._childClusters.forEach(cluster => {
          this.showClusterTableRows(cluster);
        });
      }
    },
    showTableRow(ids) {
      ids.forEach(id => {
        var selected = this.packageData.find(x => {
          return x.Id === id;
        });
        if (selected) {
          selected.Selected = true;
        }
      });
    },
    showPackageWeb(data) {
      this.clearPackageWeb();
      this.selectedLocationDetailWeb = data;
      var bounds = [];
      if (data.Lat !== 0 && data.Lng !== 0) bounds.push([data.Lat, data.Lng]);
      data.PackageDetails.forEach(p => {
        if (
          this.transitFilter[p.TransitStatus] === true &&
          (p.IsRefrigerated || !this.showRefrigeratedOnly) &&
          p.ContentsValue >= this.minimumPackageValue
        ) {
          if (
            data.Lat !== 0 &&
            data.Lng !== 0 &&
            p.DestLat !== 0 &&
            p.DestLon !== 0
          ) {
            // eslint-disable-next-line
            var polyLine = new L.Polyline(
              [
                [data.Lat, data.Lng],
                [p.DestLat, p.DestLon]
              ],
              {
                color: "black",
                weight: 1,
                opacity: 1,
                smoothFactor: 1,
                dashArray: "10 4"
              }
            );
            this.packageDetailSpiderMarkers.push(polyLine);
          }
          if (p.DestLat !== 0 && p.DestLon !== 0) {
            var marker = this.getPackageDetailMarker(p);
            this.packageDetailSpiderMarkers.push(marker);
            bounds.push([p.DestLat, p.DestLon]);
          }
        }
      });
      try {
        this.packageDetailSpiderMarkers.forEach(layer => {
          layer.addTo(this.map);
        });
      } catch (e) {}
      this.zoomToBounds(bounds);
      this.markerclusters.refreshClusters();
    },
    sort(arr, desc, key) {
      var sortedArr = arr.sort(function(a, b) {
        if (a[key] && !b[key]) return 1;
        else if (!a[key] && b[key]) return -1;
        else if (!a[key] && !b[key]) return 0;
        return a[key]
          .toString()
          .toLowerCase()
          .localeCompare(b[key].toString().toLowerCase(), undefined, {
            numeric: true,
            sensitivity: "base"
          });
      });
      if (desc) return sortedArr.reverse();
      return sortedArr;
    },
    stripKey(key) {
      return key.replace(/\W/g, "");
    },
    zoomToBounds(bounds) {
      if (bounds.length > 0) {
        var map = document.getElementById("map");
        var paddingBottom = 50;
        if (this.showGrid) paddingBottom = map.offsetHeight * 0.5;
        var paddingLeft = 50;
        if (this.drawerOpen()) paddingLeft = this.$store.navWidth + 50;
        this.map.fitBounds(bounds, {
          paddingTopLeft: [paddingLeft, 50],
          paddingBottomRight: [50, paddingBottom]
        });
      }
    },
    zoomToLatLng(lat, lng) {
      if (lat !== 0 && lng !== 0) {
        var map = document.getElementById("map");
        var paddingBottom = 50;
        if (this.showGrid) paddingBottom = map.offsetHeight * 0.5;
        var paddingLeft = 50;
        if (this.drawerOpen()) paddingLeft = this.$store.navWidth + 50;
        this.map.fitBounds(
          [
            [lat + 0.01, lng - 0.01],
            [lat - 0.01, lng + 0.01]
          ],
          {
            paddingTopLeft: [paddingLeft, 50],
            paddingBottomRight: [50, paddingBottom]
          }
        );
      }
    },
    zoomToShowAllMarkers() {
      this.clearPackageWeb();
      if (this.markers.length > 0) {
        var bounds = [];
        this.markers.forEach(m => {
          if (m.properties.Lat !== 0 && m.properties.Lng !== 0)
            bounds.push([m.properties.Lat, m.properties.Lng]);
        });
        this.zoomToBounds(bounds);
      }
    }
  },
  watch: {
    currentTab: /* istanbul ignore next */ function(val) {
      this.drawMarkers();
      this.clearPackageWeb();
    },
    drawer: /* istanbul ignore next */ function(val) {
      var grid = document.getElementById("current-overview-map-vue");
      var direction = -1;
      if (!val) direction *= -1;
      var offset = this.$store.navWidth * 0.5 * direction;
      if (grid) this.map.panBy([offset, 0], { duration: 0.2 });
    },
    selectedLocations: /* istanbul ignore next */ function(val) {
      this.drawMarkers();
      this.clearPackageWeb();
    },
    showGrid: /* istanbul ignore next */ function(val) {
      if (!val && !this.showMap) this.showMap = true;
      var grid = document.getElementById("current-overview-map-vue");
      var percent = 0.4;
      if (window.innerWidth < 760) percent = 0.5;
      if (!val) percent *= -1;
      if (grid) {
        var offset = grid.offsetHeight * percent * 0.5;
        this.map.panBy([0, offset], { duration: 0.2 });
      }
    },
    showRefrigeratedOnly: /* istanbul ignore next */ function(val) {
      this.drawMarkers();
      if (this.selectedLocationDetailWeb) {
        this.resetSelectedLocationDetailWeb();
      } else this.clearPackageWeb();
    }
  }
};
